import { SxProps, Stack } from '@mui/material'
import { useRef, useState } from 'react'

import { LangButton, LangList } from '@entities/lang-switcher'

interface PropsInterface {
  sx?: SxProps
}

export default function LanguageSwitcher({ sx }: PropsInterface) {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLButtonElement>(null)

  const handleClick = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Stack justifyContent="center" height={{ xs: 64, md: '100%' }} sx={sx}>
      <LangButton open={open} handleClick={handleClick} ref={ref} />
      <LangList open={open} anchorEl={ref.current} handleClose={handleClose} />
    </Stack>
  )
}
